import { DataStatesWrapper } from "shared/ui/data-states-wrapper";
import { ChatViewStates } from "shared/ui/messages/components/view/states";

import { useAccountDetailsContext } from "@/modules/pipeline/account-details/context";
import { MessagingContextProvider } from "@/modules/messages/context";
import { ChatView } from "@/modules/messages/components/view";
import { useQueryFetchCustomerToChatOnAccountDetails } from "@/modules/messages/data/queries";

export const AccountDetailsTabAeMessages = () => {
  const { campaign, account } = useAccountDetailsContext();
  const customerToChatQuery = useQueryFetchCustomerToChatOnAccountDetails(
    campaign?.id,
    account?.id
  );

  if (!campaign?.id) {
    return null;
  }

  return (
    <DataStatesWrapper
      api={customerToChatQuery}
      loading={<ChatViewStates.Loading />}
      viewName="customer to chat"
    >
      <MessagingContextProvider
        campaignId={campaign.id}
        campaignName={campaign.name}
        contactId={customerToChatQuery.data}
      >
        <div className="h-full p-5 pb-[120px]">
          <ChatView className="rounded-lg border bg-white" />
        </div>
      </MessagingContextProvider>
    </DataStatesWrapper>
  );
};
